<!-- StepTwo.vue -->
<template>
    <div class="space-y-4">
        <!-- Company Details  -->
        <div>
            <div class="mx-2 text-xl font-semibold">Company Details</div>

            <div class="grid grid-cols-1 gap-5 m-2 md:grid-cols-2">
                <!-- Company Registration Number -->
                <div>
                    <div class="block text-sm font-semibold text-gray-700">Company Registration Number*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.companyRegistrationNumber"
                            type="text"
                            placeholder="Company Registration Number"
                            :variant="localErrors('company_registration_number') ? 'danger' : ''"
                        />
                        <div
                            v-if="localErrors.company_registration_number"
                            class="text-red-500"
                        >
                            {{ localErrors.company_registration_number }}
                        </div>
                    </div>
                </div>
                <div></div>

                <!-- Company Name -->
                <div>
                    <div class="block text-sm font-semibold text-gray-700">Company Name*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.companyName"
                            type="text"
                            placeholder="Company Name"
                            :variant="localErrors.company_name ? 'danger' : ''"
                        />
                        <div
                            v-if="localErrors.company_name"
                            class="text-red-500"
                        >
                            {{ localErrors.company_name }}
                        </div>
                    </div>
                </div>

                <!-- Business address -->
                <div>
                    <div class="block text-sm font-semibold text-gray-700">Company Address*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.businessAddress"
                            type="text"
                            placeholder="Business address"
                            :variant="localErrors.business_address ? 'danger' : ''"
                        />
                        <div
                            v-if="localErrors.business_address"
                            class="text-red-500"
                        >
                            {{ localErrors.business_address }}
                        </div>
                    </div>
                </div>

                <!-- Business References Name -->
                <div>
                    <div class="block text-sm font-semibold text-gray-700">Company References Name*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.businessReferencesName"
                            type="text"
                            placeholder="Business References Name"
                            :variant="localErrors.business_references_name ? 'danger' : ''"
                        />
                        <div
                            v-if="localErrors.business_references_name"
                            class="text-red-500"
                        >
                            {{ localErrors.business_references_name }}
                        </div>
                    </div>
                </div>

                <!-- Business References Address -->
                <div>
                    <div class="block text-sm font-semibold text-gray-700">Company References Address*</div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.businessReferencesAddress"
                            type="text"
                            placeholder="Business References Address"
                            :variant="localErrors.business_references_address ? 'danger' : ''"
                        />
                        <div
                            v-if="localErrors.business_references_address"
                            class="text-red-500"
                        >
                            {{ localErrors.business_references_address }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            form: { type: Object, required: true },
            errors: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            localErrors() {
                return this.errors || {};
            },
        },
    };
</script>
